/* eslint-disable array-bracket-newline */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { enums } from '@kattana-io/common';
import TickersModalTab from './Tab';
import { actionUpdateModalParams } from '../../../../actions/modal_search';
import { IStore } from '../../../../reducers';
import { EXCLUDED_KINDS, SearchKind } from '../../../../reducers/modal_search';

// Tabs
const tabs: ITab[] = [
  { name: 'DEX', isActive: true, kind: enums.ETickerKind.DEX },
  { name: 'CEX', isActive: true, kind: enums.ETickerKind.CEX },
  { name: 'Testnet', isActive: true, kind: 'testnet' },
];

interface ITab {
  name: string;
  isActive: boolean;
  kind: SearchKind;
}

const TickersModalTabsSelector = () => {
  const kind = useSelector((state: IStore) => state.modal_search.kind);

  const dispatch = useDispatch();

  /**
   * Gets className for an item
   * @returns className
   */
  const getClassName = (tab: ITab) => {
    if (tab.kind !== enums.ETickerKind.UNAVAILABLE) {
      if (
        tab.kind === kind ||
        (kind === enums.ETickerKind.ALL && !EXCLUDED_KINDS.includes(tab.kind))
      ) {
        return 'tabs_container__tabs__item tabs_container__tabs__item--active';
      }
      return 'tabs_container__tabs__item';
    }
    return 'tabs_container__tabs__item tabs_container__tabs__item--disabled';
  };

  /**
   * Handle DEX, CEX, NFT POOL change
   */
  const handleKindChange = useCallback(
    (item: ITab) => {
      if (item.kind === enums.ETickerKind.UNAVAILABLE) {
        return;
      }
      if (item.kind !== kind) {
        return dispatch(
          actionUpdateModalParams({
            kind: item.kind,
            exchanges: [],
            chains: [],
          })
        );
      }
      return dispatch(
        actionUpdateModalParams({
          kind: enums.ETickerKind.ALL,
          exchanges: [],
          chains: [],
        })
      );
    },
    [dispatch, kind]
  );

  return (
    <div className='tabs_container'>
      <div className='tabs_container__tabs'>
        {tabs.map((item) => (
          <TickersModalTab
            key={item.name}
            name={item.name}
            className={getClassName(item)}
            onClick={() => handleKindChange(item)}
          />
        ))}
      </div>
    </div>
  );
};

export default TickersModalTabsSelector;
